import AddDataButton from './add-data-button';
import bundle from './bundle';

const plugin = {
  pluginName: 'Add Data',
  enabled: true,
  bundle: bundle,
  components:[{
    component: AddDataButton,
    region: 'basic-toolbar',
    sortOrder: 8
  }]
}

export default plugin;